import { createContext, useContext } from 'react'
import { UseOrderTracking } from './useOrderTracking'
import { datadogLogs } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum'

export const TrackingContext = createContext<UseOrderTracking | null>(null)

TrackingContext.displayName = 'TrackingContext'

export const useTrackingContext = () => {
  const hook = useContext(TrackingContext)

  if (hook === null) {
    const errorMessage = 'TrackingContext value is null'
    datadogLogs.logger.error(errorMessage)
    datadogRum.addError(new Error(errorMessage), {
      page: 'MyGoustoPage',
      errorMessage: errorMessage,
    })

    throw new Error('TrackingContext value is null')
  }

  return hook
}
